'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _auroraJavascriptUtils = require('@unitedtraders/aurora-javascript-utils');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _FeeType = require('../enums/FeeType');

var _FeeType2 = _interopRequireDefault(_FeeType);

var _MoneyModel = require('../MoneyModel');

var _MoneyModel2 = _interopRequireDefault(_MoneyModel);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function validate(value) {
  return this.type === _FeeType2.default.MoneyValue && value >= 0 || !value || value.value >= 0;
}

function BrokerFee(domainBuilder) {
  domainBuilder.defineModel('BrokerFee', 'brokerFee', function (model) {
    return model.define({
      defaults: {
        type: _FeeType2.default.factory.value(null),
        ratePerShare: _MoneyModel2.default.value(null).has.check(validate, _auroraJavascriptUtils.validator.min(0).message),
        percent: Number.value(null).has.check(validate, _auroraJavascriptUtils.validator.min(0).message)
      },
      toJSON: function toJSON() {
        return _underscore2.default.omit(this.attributes, [this.type === _FeeType2.default.MoneyValue ? 'ratePerShare' : 'percent']);
      }
    });
  });
}

exports.default = BrokerFee;


//////////////////
// WEBPACK FOOTER
// ./~/@unitedtraders/statements-domain/dist/models/rpc/BrokerFee.js
// module id = 1441
// module chunks = 118